import { FC, ReactElement, memo } from 'react';
import Skeleton from 'react-loading-skeleton';

export const ItemsInventoryListItemSkeleton: FC = memo((): ReactElement => {
  return (
    <div className="items-inventory-list-item items-inventory-list-item__grid-template">
      <div className="items-inventory-list-item__element justify-items-start gap-20">
        <div>
          <Skeleton width={80} height={55} style={{ borderRadius: 8 }} />
        </div>
        <Skeleton width="80%" height={16} className="items-inventory-list-item_border" />
      </div>

      <div className="items-inventory-list-item__element items-inventory-list-item_border">
        <Skeleton width="90%" height={16} />
      </div>

      <div className="items-inventory-list-item__element items-inventory-list-item_border">
        <Skeleton width={60} height={16} />
      </div>

      <div className="items-inventory-list-item__element items-inventory-list-item_border">
        <Skeleton width={40} height={16} />
      </div>

      <div className="items-inventory-list-item__element items-inventory-list-item_border">
        <Skeleton width={40} height={16} />
      </div>

      <div className="items-inventory-list-item__element items-inventory-list-item_border">
        <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
      </div>

      <div className="items-inventory-list-item__element items-inventory-list-item_border">
        <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
      </div>
    </div>
  );
});
